import "./contact.css";
import { MdOutlineMail } from "react-icons/md";
import { ImWhatsapp } from "react-icons/im";
import React, { useRef } from "react";
import emailjs from "emailjs-com";
import { motion } from "framer-motion";
import EarthCanvas from "../3D/Earth";
function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      "service_4td586t",
      "template_kpdjzuq",
      form.current,
      "9TxBzr_CWefE0r88i"
    );
    e.target.reset();
  };
  return (
    <section id="contact">
      <motion.h5 whileInView={{ opacity: 1, y: 0 }}
      initial={{ opacity: 0, y: -50 }}
      transition={{
        duration:1.25,type: "spring",
      }}>My contacts</motion.h5>
      <motion.h2 whileInView={{ opacity: 1, y: 0 }}
      initial={{ opacity: 0, y: -50 }}
      transition={{
        duration:1.25,type: "spring",delay:0.3
      }}>Connect with me</motion.h2>
      <div className="contact_container">
        <div className="contact-firstcontent">
          <div className="contact_options">
            <article className="contact_option">
              <MdOutlineMail className="contact_option-icon" />
              <h4>Email</h4>
              <h5>dhanushsaji1@gmail.com</h5>
              <a href="mailto:dhanushsaji1@gmail.com" target="_blank">
                {" "}
                Send a message
              </a>
            </article>
            <article className="contact_option">
              <ImWhatsapp className="contact_option-icon" />
              <h4>Whatsapp</h4>
              <h5>+91 8547074716</h5>
              <a href=" https://wa.me/918547074716?text=Hello" target="_blank">
                {" "}
                Send a message
              </a>
            </article>
          </div>
          <form ref={form} onSubmit={sendEmail}>
            <input
              type="text"
              name="name"
              placeholder="Your Full Name"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              required
            />
            <textarea
              name="message"
              rows="7"
              placeholder="Your Message"
              required
            ></textarea>
            <button type="submit" className="btn btn-primary">
              Send Message
            </button>
          </form>
        </div>
        <motion.div
          initial={{ x: -1000 }}
          animate={{ x: 0 }}
          transition={{ duration: 0.5 }}
          className="earthCanvasDiv"
        >
          <EarthCanvas />
        </motion.div>
      </div>
    </section>
  );
}

export default Contact;
